<template>
	<div id="app" class="container-fluid d-flex flex-column sticky-footer-wrapper">
		<header>
			<SideNavi :profile_name="this.$store.getters.profileGetName" />
		</header>

		<main role="main" class="flex-fill">
			<div v-if="this.$store.state.show_loading == 1" class="text-center gold mt-5 pt-5">
				<img
					:src="this.$store.state.layout.logo"
					alt="iAMc"
					width="auto"
					height="35"
					class="m-4"
				/><br />
				<i class="fas fa-atom fa-spin fa-2x"></i>
			</div>
			<div v-else>
				<router-view />
			</div>
		</main>

		<footer v-if="this.$store.state.profile.status == 1" class="footer mt-auto py-1">
			<PageFooter />
		</footer>
	</div>
</template>

<script>
import SideNavi from './components/SideNavi.vue';
import PageFooter from './components/PageFooter.vue';

import axios from 'axios';

import * as Cookie from '@/assets/js/cookie.js';

export default {
	name: 'App',
	components: {
		SideNavi,
		PageFooter,
	},
	data() {
		return {
			temp: '',
		};
	},
	computed: {},
	mounted: function () {
		this.checkLoginStatus();
		document.title = this.$route.meta.title + ' - iAMconnected App';
	},
	methods: {
		checkout() {
			this.$refs.checkoutRef.redirectToCheckout();
		},
		checkLoginStatus() {
			console.log('checkLoginStatus');
			this.$store.state.show_loading = 1;
			if (this.$route.name == 'reset_password' || this.$route.name == 'login') {
				this.$store.state.show_loading = 0;
			} else {
				this.$store.state.session_id = Cookie.getCookie('user_session');
				this.checkVersion();
				this.preFlightCheck(this.$store.state.session_id);

				if (this.$store.state.session_id == '') {
					console.log('no user---------');
					this.$router.push('/login');
				} else {
					console.log('get profile---------');
					this.getProfile(this.$store.state.session_id);
				}
				this.$store.state.show_loading = 0;
			}
		},
		checkVersion() {
			var cookieVersion = Cookie.getCookie('version');
			var storeVersion = this.$store.getters.appVersion;
			console.log({cookieVersion, storeVersion})
			if (cookieVersion !== storeVersion) {
				Cookie.setCookie('version', storeVersion, this.$store.state.app_domain, '3');
				Cookie.setCookie('version', storeVersion, 'iamconnected.loc', '3');
				console.log('reload APP');
				// location.reload();
			}
			cookieVersion = Cookie.getCookie('version');
			console.log('cookieVersion:' + cookieVersion);
		},
		getMenu(session_id) {
			console.log('APP: getMenu');
			let _this = this;
			axios({
				url: _this.$store.state.api_url + 'userMenuGet',
				params: {
					session_id: session_id,
				},
			})
				.then(function (response) {
					if (response.data.menu.status == 1) {
						_this.$store.commit('menuSet', response.data);
					}
				})
				.catch(function () {
					console.log('Error: getMenu.');
				});
		},
		getProfile(session_id) {
			let _this = this;
			axios({
				url: _this.$store.state.api_url + 'userGet',
				params: {
					session_id: session_id,
					log_session: 1,
				},
			})
				.then(function (response) {
					if (response.data.profile.status == 1) {
						_this.$store.commit('profileSet', response.data);
						axios.defaults.headers.common['Authorization'] = response.data.profile.session_id;

						if (typeof _this.$route.meta.min_level !== 'undefined') {
							console.log(_this.$route.meta.min_level);
							if (_this.$route.meta.min_level === 'admin') {
								if (response.data.profile.level < 90) {
									console.log('User level not accepted - Admin Only');
									_this.$router.push('/');
								}
							} else if (_this.$route.meta.min_level === 'editor') {
								if (response.data.profile.level < 60) {
									console.log('User level not accepted - Editors Only');
									_this.$router.push('/');
								}
							} else if (_this.$route.meta.min_level === 'coach') {
								if (response.data.profile.level < 30) {
									console.log('User level not accepted - Team Coaches Only');
									_this.$router.push('/');
								}
							}

							/*if(response.data.profile.timezoneOffsetH === null){
							_this.$router.push('/profile');
						}*/
						}

						_this.getMenu(_this.$store.state.session_id);
						_this.getNotifications();
					} else if (response.data.profile.status == -5) {
						if (_this.$route.name != 'login') {
							_this.$router.push('/login');
						}
					}

					_this.$store.state.show_loading = 0;
				})
				.catch(function () {
					console.log('Error: getProfile.');
				});
		},
		getNotifications() {
			var _this = this;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + 'notificationsGet',
				params: params,
			})
				.then(function (response) {
					console.log('notificationsGet');
					if (response.data !== null) {
						_this.$store.commit('notificationsSet', response.data.store_notifications);

						if (response.data.items) {
							for (const obj of Object.values(response.data.items)) {
								_this.$toast.open({
									message: obj.text,
									type: obj.type,
									onClose: function toastClose() {},
									onClick: function toastClick() {
										console.log('toastClick');
										params.append('id', obj.id);

										axios({
											url: _this.$store.state.api_url + 'notificationsClose',
											params: params,
										})
											.then(function (response) {
												if (obj.link && obj.link !== null) {
													if (response.data.status == 1) {
														window.location.href = obj.link;
													}
												}
											})
											.catch(function (error) {
												console.log(error);
											});
									},
								});
							}
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		preFlightCheck(session_id) {
			let _this = this;
			console.log('preFlightCheck:' + session_id);

			_this.$store.commit('preFlightDataSet', null);

			let params = new URLSearchParams();
			params.append('token', session_id);

			axios({
				url: _this.$store.state.api_url + 'preFlightCheck',
				params: params,
			})
				.then(function (response) {
					if (response.data !== 'null') {
						_this.$store.commit('preFlightDataSet', response.data);
						_this.$router.push(response.data.link);
					}
				})
				.catch(function () {
					console.log('Error: preFlightCheck.');
				});
		},
	},
	created() {
		const tld = window.location.origin.split('.').pop();
		if (tld == 'loc') {
			this.$store.commit('appDomainSet', process.env.VUE_APP_LOCAL_DOMAIN);
			this.$store.commit('appUrlSet', process.env.VUE_APP_LOCAL_API);
		}
		Cookie.setCookie('SD', 'app', this.$store.state.app_domain, '3');
		Cookie.setCookie('SD', 'app', 'iamconnected.loc', '3');
	},
	watch: {
		$route(to) {
			document.title = to.meta.title + ' - iAMconnected App';
			this.checkVersion();
		},
	},
};
</script>

<style scoped>
/* include main_styles.css here to override bootstrap theming on build */
@import 'https://media.iamconnected.com/css/main_styles.css';
body,
.sticky-footer-wrapper {
	min-height: 100vh;
}

.flex-fill {
	flex: 1 1 auto;
}
</style>
